import { Box, FormControl, FormLabel, Text, Textarea } from "@chakra-ui/react";
import { visibleLength } from "../../../../../common/text/visibleLength";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type {
  SourcingEventDto,
  SourcingEventPatchDto,
} from "../../../../../autogen/bff-api";
import { useEditor } from "../../../../../common/editing/save-coordinator";

const PROVISION = "forsyningsforskriften § 16-3 (1)";

export const ShortRequestDeadlineReason = ({
  eventId,
  savedReason,
  minDays,
  generalDays,
}: {
  eventId: string;
  savedReason: string | null | undefined;
  minDays: number;
  generalDays: number;
}) => {
  const { t } = useTranslation();
  const { updateField } = useEditor<SourcingEventDto, SourcingEventPatchDto>(
    eventId,
  );
  const [reason, setReason] = useState(savedReason ?? "");
  return (
    <Box
      mt="6"
      px="4"
      py="3"
      borderRadius="md"
      bg="smWarningSoft"
      borderWidth="1px"
      borderColor="smWarningSoftBorder"
    >
      <FormControl isRequired>
        <FormLabel fontSize="sm" fontWeight="semibold" mb="1">
          {t(
            "Why the deadline for requests to participate is under {{generalDays}} days",
            { generalDays },
          )}
        </FormLabel>
        <Text fontSize="sm" mb="2">
          {t(
            "{{generalDays}} days is the general rule in {{provision}}. A shorter deadline, down to {{minDays}} days, needs a reason. It goes into the procurement protocol.",
            { generalDays, minDays, provision: PROVISION },
          )}
        </Text>
        <Textarea
          rows={3}
          bg="smBackground"
          value={reason}
          onChange={(event) => {
            setReason(event.target.value);
            updateField(
              {
                publicContext: {
                  shortRequestDeadlineJustification:
                    visibleLength(event.target.value) > 0 ? event.target.value : null,
                },
              },
              { debounceMs: 300 },
            );
          }}
        />
      </FormControl>
    </Box>
  );
};
